import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'
import ClientProjectsList from './ClientProjectsList'
import './ClientProjects.sass'

class ClientProjects extends Component {
  static propTypes = {
    match: PropTypes.object
  }
  constructor (props) {
    super(props)
    const { match } = this.props
    this.clientName = match.params.clientName || ''
  }
        
  render () {
    return (
      <DocumentTitle title='Client pending projects | Atheneum Partners'>
        <ClientProjectsList clientName={this.clientName}/>
      </DocumentTitle>
    )
  }
}

export default ClientProjects
